function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { connect } from 'react-redux';
import Toast from './Toast.react';
var Notification = function Notification(_ref) {
  var notification = _ref.notification;
  return /*#__PURE__*/React.createElement("div", {
    id: "notification",
    className: "notification"
  }, /*#__PURE__*/React.createElement("div", {
    className: "notification__toast"
  }, notification.toast.map(function (toast) {
    if (!toast.visible) return null;
    return /*#__PURE__*/React.createElement(Toast, _extends({}, toast, {
      key: toast.id
    }));
  })));
};
var mstp = function mstp(state) {
  return {
    notification: state.notification
  };
};
export default connect(mstp, null)(Notification);